import { Suspense, useEffect } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { Exceptions } from '@/routes/single-sign-on/exceptions'
import { ExceptionsFallback } from '@/routes/single-sign-on/exceptions/fallback'
import { SingleSignOnFallback } from '@/routes/single-sign-on/fallback'
import { Jit } from '@/routes/single-sign-on/jit'
import { JitFallback } from '@/routes/single-sign-on/jit/fallback'
import { MandatorySso } from '@/routes/single-sign-on/mandatory-sso'
import { MandatorySsoFallback } from '@/routes/single-sign-on/mandatory-sso/fallback'
import { SsoConfig } from '@/routes/single-sign-on/sso-config'
import { SsoConfigFallback } from '@/routes/single-sign-on/sso-config/fallback'

export const SingleSignOnPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()

  useEffect(() => {
    rbac.company(idCompany).users.update.ensure()
  }, [idCompany, rbac])

  return (
    <LayoutPage
      browserTitle="Single sign-on"
      fallback={<SingleSignOnFallback />}
    >
      <div className="flex flex-col gap-6 pb-25">
        <Suspense fallback={<SsoConfigFallback />}>
          <SsoConfig />
        </Suspense>
        <Suspense fallback={<MandatorySsoFallback />}>
          <MandatorySso />
        </Suspense>
        <Suspense fallback={<ExceptionsFallback />}>
          <Exceptions />
        </Suspense>
        <Suspense fallback={<JitFallback />}>
          <Jit />
        </Suspense>
      </div>
    </LayoutPage>
  )
}
